<template>
  <div class="carrier-list">
    <template v-if="$store.state.userLevel">
      <!-- <template> -->
      <div class="header">
        <div class="align-start">
          <div v-if="anchorBasicInfo.isLiving" class="avatar-container" @click="goDatav(anchorBasicInfo.eaId)">
            <img class="avatar" :src="$changeCDN(anchorBasicInfo.avatar)||$defaultSrc" alt="头像" />
            <div class="live-icon">
              <div class="wave-icon">
                <span class="line" style="animation-delay:-.3s" />
                <span class="line" />
                <span class="line" style="animation-delay:.3s" />
              </div>
              直播中
            </div>
          </div>
          <div v-else class="avatar-container">
            <img class="avatar" :src="$changeCDN(anchorBasicInfo.avatar)||$defaultSrc" alt="头像" />
          </div>
          <span class="roughly">
            <div class="name">{{ anchorBasicInfo.name }}</div>
            <div class="info__box">
              <div class="ksId">ID：{{ anchorBasicInfo.userId || '-' }}</div>
              <img src="../../../static/images/copy.png" alt="复制" style="width: 0.24rem;height: 0.24rem" @click="copyId">
              <div class="fans">{{ $retainWan(anchorBasicInfo.fans) }}粉丝</div>
            </div>
            <div class="approve__box">
              <!--      达人认证        -->
              <span class="approve" v-if="anchorBasicInfo.verifiedDetail && anchorBasicInfo.verifiedDetail.description " >
                <img src="../../../static/images/guanfang.png" alt="认证" style="width: 0.26rem;height: 0.26rem">
                <span class="approve-text">{{ anchorBasicInfo.verifiedDetail.description}}</span>

              </span>
              <!--      品牌认证        -->
              <span class="approve" v-if="anchorBasicInfo.isBrand">
                <img src="../../../static/images/zibo.png" alt="品牌自播" style="width: 0.89rem;height: 0.26rem">
              </span>
              <!--      已开通小店        -->
              <span class="approve" v-if="anchorBasicInfo.hasKwaiShop">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="1" y="1" width="14" height="14" rx="2" fill="#FC4A21"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.547 3.625C12.1004 3.625 12.5486 4.07455 12.547 4.62801L12.5409 6.66741C12.5409 7.11147 12.3717 7.54013 12.0608 7.86987L12.0626 11.5495C12.0628 12.102 11.615 12.55 11.0626 12.55H5.10868C4.55678 12.55 4.10922 12.1029 4.10868 11.551L4.10508 7.86767C3.79417 7.53793 3.625 7.10927 3.625 6.66522L3.63115 4.62199C3.6328 4.07088 4.08003 3.625 4.63114 3.625H11.547ZM9.37687 7.9622C9.02938 8.28315 8.5653 8.46341 8.08293 8.46341C7.60056 8.46341 7.13648 8.28535 6.78899 7.9622C6.31805 8.39526 5.64821 8.56233 5.01953 8.40405L5.0241 11.6707H11.1509L11.1463 8.40405C10.5154 8.56233 9.84552 8.39526 9.37687 7.9622ZM6.11923 4.53205C6.13526 4.31172 5.96963 4.12011 5.7493 4.10409C5.52897 4.08806 5.33736 4.25369 5.32134 4.47402L5.13854 6.98732C5.12251 7.20765 5.28813 7.39926 5.50847 7.41528C5.7288 7.43131 5.9204 7.26568 5.93643 7.04535L6.11923 4.53205ZM8.34594 4.1C8.12509 4.09499 7.94199 4.26998 7.93698 4.49083L7.87989 7.01013C7.87489 7.23098 8.04987 7.41408 8.27073 7.41909C8.49158 7.42409 8.67468 7.24911 8.67969 7.02825L8.73678 4.50896C8.74178 4.2881 8.5668 4.105 8.34594 4.1ZM10.3458 4.52415C10.3333 4.30358 10.502 4.1147 10.7226 4.10225C10.9431 4.08981 11.132 4.25853 11.1445 4.47909L11.2864 6.99503C11.2989 7.21559 11.1301 7.40448 10.9096 7.41692C10.689 7.42937 10.5001 7.26065 10.4877 7.04009L10.3458 4.52415Z" fill="white"/>
                </svg>
                 <router-link v-if="anchorBasicInfo.shop.id" :to="`/shop/${anchorBasicInfo.shop.id}`" target="_blank" class="approve-text hover-text">{{anchorBasicInfo.shop.name}}</router-link>
                 <span v-else class="approve-text">{{anchorBasicInfo.shop.name}}</span>
              </span>
              <!--      内容课程        -->
              <span class="approve" v-if="anchorBasicInfo.payForKnowledge">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="14" height="14" rx="2" fill="#FD9926"/>
                  <path d="M11.79 4.94L10.25 3.26C10.09 3.1 9.86999 3 9.64999 3H4.35C4.13 3 3.91 3.1 3.75 3.26L2.21 4.94C1.93 5.26 1.93 5.72 2.21 6.04L6.64999 10.84C6.72999 10.94 6.86999 11 6.98999 11C7.12999 11 7.24999 10.94 7.32999 10.84L11.79 6.04C12.09 5.72 12.09 5.24 11.79 4.94ZM11.51 5.76L7.04999 10.56C7.02999 10.58 7.00999 10.58 6.98999 10.58L6.96999 10.56L2.53 5.76C2.39 5.6 2.39 5.36 2.53 5.2L4.07 3.52C4.15 3.44 4.27 3.38 4.37 3.38H9.66999C9.78999 3.38 9.88999 3.42 9.96999 3.52L11.51 5.2C11.65 5.36 11.65 5.6 11.51 5.76Z" fill="white" stroke="white" stroke-width="0.5"/>
                </svg>
                <span class="approve-text">内容课程</span>
              </span>
           </div>
          </span>
        </div>
        <div class="info">
          <span class="text">性别：{{ gender[anchorBasicInfo.gender] }}</span>
          <span class="text">星座：{{ anchorBasicInfo.constellation }}</span>
          <span class="text">位置：{{ anchorBasicInfo.region }}</span>
        </div>
       <div :class="{ introduction: true, oneLine: !showMore }">简介：{{ anchorBasicInfo.memo }}</div>
       <div class="more-btn" @click="showMore = !showMore">
         {{ showMore ? '收起' : '更多' }}
         <van-icon :name="showMore ? 'arrow-up' : 'arrow-down'" />
       </div>
       <div class="motend">
        <div class="motend_box">
          <span>近30天粉丝</span>
          <p>{{anchorliveData.fansDiff}}</p>
        </div>
        <div class="motend_box">
          <span>近30天开播</span>
          <p>{{anchorliveData.liveCount}}</p>
        </div>
        <div class="motend_box">
          <span>发布作品</span>
          <p>{{anchorliveData.totalOpus}}</p>
        </div>
        <div class="motend_box">
          <span>带货视频</span>
          <p>{{anchorliveData.salesOpus}}</p>
        </div>
       </div>
        <div class="btn-row">
          <van-button @click="chooseCollection">{{ anchorBasicInfo.isFavorite ? '已关注' : '关注' }}</van-button>
          <van-button @click="monitor">{{ anchorBasicInfo.isSubscribe ? '已监控' : '监控' }}</van-button>
<!--          <van-button @click="contact">联系Ta</van-button>-->
          <van-button v-if="anchorBasicInfo.isLiving" @click="goDatav(anchorBasicInfo.eaId)">数据大屏</van-button>
        </div>
      </div>
      <div class="anchor-links">
        <van-tabs  v-model="active" color="#2A89F4" title-active-color="#2A89F4" line-width="1.2rem">
          <van-tab v-for="(tab,index) in tabs" :key="index" :title="tab.title">
            <component :is="tab.component" :fansData="anchorBasicInfo" @monitor="monitor" :info="anchoInfo"/>
          </van-tab>
        </van-tabs>
      </div>
      <More />
<!--      <van-popup v-model="showContact">-->
<!--        <AnchorContact :links="links" :vip="$_.get(anchorBasicInfo, 'contact')" />-->
<!--      </van-popup>-->
    </template>
    <LoginModule v-else />
  </div>
</template>

<script>
import FansAnalysis from '@/modules/anchor/FansAnalysis.vue';
import OpusAnalysis from '@/modules/anchor/newOpusAnalysis/index.vue';
import LiveCalendar from '@/modules/anchor/LiveCalendar/index.vue';
import ShopAnalysis from '@/modules/anchor/ShopAnalysis/index.vue';
import LiveTrend from '@/modules/anchor/liveTrend/index.vue'
import Delivery from '@/modules/anchor/Delivery/index.vue'
import routePushShare from '@/plugins/getShareCode';

export default {
  components: { FansAnalysis, OpusAnalysis, LiveCalendar, ShopAnalysis,LiveTrend,Delivery},
  data() {
    return {
      tabs: [
        { title: '带货分析', component: 'ShopAnalysis' },
        { title: '直播趋势', component: 'LiveTrend' },
        { title: '直播日历', component: 'LiveCalendar' },
        { title: '粉丝分析', component: 'FansAnalysis' },
        { title: '视频带货', component: 'Delivery' },
        { title: '作品分析', component: 'OpusAnalysis' },
      ],
      anchorBasicInfo: {},
      anchoInfo:[],
      active: Number(this.$route.query.banner) || 0,
      showContact: false,
      showMore: false,
      gender: { 0: '女', 1: '男' },
      meaning: {
        cellphone: { label: '手机', key: 3 },
        qq: { label: 'QQ', key: 1 },
        wechat: { label: '微信', key: 2 }
      },
      anchorData:{}
    };
  },
  computed: {
    anchorliveData() {
      return {
        fansDiff: this.anchorData?.liveStatistic?.fansDiff > 0 || this.anchorData?.liveStatistic?.fansDiff === 0 ? '+' + this. $retainWan(this.anchorData?.liveStatistic?.fansDiff) : this. $retainWan(this.anchorData?.liveStatistic?.fansDiff),
        liveCount: this.anchorData?.liveStatistic?.liveCount,
        salesOpus:this.anchorData?.opusStatistic?.salesOpus.opusCount,//带货视频
        totalOpus:this.anchorData?.opusStatistic?.totalOpus.opusCount,//发布作品
      }
    },
    routeQuery() {
      return this.$route.query;
    },
    links() {
      let linksArray = [];
      Object.keys(this.anchorBasicInfo?.contact || {}).forEach(keys => {
        if (
          this.meaning[keys] &&
          this.$_.get(this, `anchorBasicInfo.contact.${keys}`, {}) !== '-'
        ) {
          linksArray = linksArray.concat(
            this.anchorBasicInfo.contact[keys].split('#').map(ele => {
              return {
                label: this.meaning[keys].label,
                value: ele,
                key: this.meaning[keys].key
              };
            })
          );
        }
      });
      return linksArray.sort((a, b) => a.key - b.key);
    }
  },
  watch: {
    routeQuery(newValue) {
      this.active = Number(newValue.banner);
      this.$toast.clear();
    }
  },
  mounted() {
    this.query();
  },
  methods: {
    copyId(){
      const input = document.createElement("input");
      document.body.append(input);
      input.value =  this.anchorBasicInfo.userId
      input.style.opacity = "0";
      input.select();
      document.execCommand("Copy");
      this.$toast('复制成功')
      document.body.removeChild(input);
    },
    goDatav(eaId) {
      if (this.$store.state.userLevel && this.$store.state.userLevel <= 100) {
        location.href = 'https://datav.bihukankan.com/mobile?eaId=' + eaId
      } else {
        this.$store.commit('WRITEOVERLAYSHOW', { status: true, textChange: 'goDatav' });
      }
    },
    chooseCollection() {
      if (this.$store.state.userLevel && this.$store.state.userLevel <= 100) {
        if (this.anchorBasicInfo.isFavorite) {
          this.deCollection();
        } else {
          this.putCollection();
        }
      } else {
        this.$store.commit('WRITEOVERLAYSHOW', { status: true,textChange:'monitor' });
      }
    },
    deCollection() {
      this.$dialog.confirm({
        title: '提示',
        message: `您将取消对${this.anchorBasicInfo.name}的关注`
      }).then(() => {
        this.$toast.clear();
        this.$showLoading();
        this.$del({
          road: 'favorites',
          data: { road: 'gifshow'},
          params: { userId: this.anchorBasicInfo.userId},
          version: 'v2'
        })
        this.$toast.clear();
            this.$toast(`取消成功`);
            this.$set(this.anchorBasicInfo, `isFavorite`, false);
      });
    },
    putCollection() {
      this.$dialog.confirm({
        title: '提示',
        message: `您将关注${this.anchorBasicInfo.name}`
      }).then(() => {
        // 清空弹窗
        this.$toast.clear();
        // 出现loading
        this.$showLoading();
        // 数据发送
        this.$post({
          road: 'favorites',
          data: { road: 'gifshow' },
          params: { userId: this.anchorBasicInfo.userId},
          version: 'v2'
        })
            this.$toast.clear();
            this.$toast(`关注成功`);
            this.$set(this.anchorBasicInfo, `isFavorite`, true);
      });
    },
    monitor() {
      if (this.$store.state.userLevel && this.$store.state.userLevel <= 100) {
        if (this.anchorBasicInfo.isSubscribe) {
          this.delMonitor();
        } else {
          this.putMonitor();
        }
      } else {
        this.$store.commit('WRITEOVERLAYSHOW', { status: true,textChange:'monitor' });
      }
    },
    putMonitor() {
      if (this.$store.state.userLevel && this.$store.state.userLevel > 100) {
        this.$store.commit('WRITEOVERLAYSHOW', { status: true,textChange:'monitor' });
        return
      }
      this.$dialog.confirm({
        title: '提示',
        message: `您将开启对${this.anchorBasicInfo.name}的直播监控，开启后，当该播主再次直播结束即可获得分析数据`
      }).then(() => {
        // 清空弹窗
        this.$toast.clear();
        // 出现loading
        this.$showLoading();
        // 数据发送
        this.$put({
          road: 'liveStream',
          data: { road: 'gifshow' },
          params: { userId: this.anchorBasicInfo.userId, barrage: true },
          version: 'v2'
        }).then(res => {
          this.$toast.clear();
          this.$toast('监控成功');
          this.$set(this.anchorBasicInfo, `isSubscribe`, true);
        }).catch(err => {
          this.$toast.clear();
          this.$showNoneMonitor();
        });
      });
    },
    delMonitor() {
      this.$dialog.confirm({
        title: '提示',
        message: `您将取消对${this.anchorBasicInfo.name}的直播监控，取消后，将不再获得该播主的直播分析和电商分析数据`
      }).then(() => {
        this.$toast.clear();
        this.$showLoading();
        this.$del({
          road: 'liveStream',
          data: { road: 'gifshow' },
          params: { userId: this.anchorBasicInfo.userId, barrage: true },
          version: 'v2'
        })
          .then(res => {
            this.$toast.clear();
            this.$toast(`取消成功`);
            this.$set(this.anchorBasicInfo, `isSubscribe`, false);
          })
          .catch(err => {
            this.$toast.clear();
            this.$toast('取消失败');
          });
      });
    },
    query() {
      this.$showLoading();
      
      this.$get({
        road: 'anchor',
        data: { road: 'gifshow', anchorId: this.$route.params.id },
        version: 'v2'
      }).then(res => {
        this.anchorBasicInfo = res;
        this.$store.commit('WRITENEXTPAGE', {
          meta: {
            shareTitle: `${this.anchorBasicInfo.name} 的详细粉丝画像与直播分析和电商带货能力评估`,
            shareDesc: '关于达人的重要信息都在这里，联系 ta 合作一波吧',
            fullPath: this.$route.fullPath
          }
        });
        routePushShare();
      }).finally(() => {
        this.$toast.clear()
      });
      const today = new Date();
      const yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
      const formattedYesterday = `${yesterday.getFullYear()}${String(yesterday.getMonth() + 1).padStart(2, '0')}${String(yesterday.getDate()).padStart(2, '0')}`;
      this.$get({
          road: 'anchorData',
          data: { anchorId: this.$route.params.id },
          params: { timeMode: 30, time: formattedYesterday },
          version: 'v22'
        }).then(res => {
          this.anchorData = res.data
        }).finally(() => {
          this.$toast.clear()
        })

      this.$get({
        road: 'someDaysNumChange',
        data: { road: 'gifshow', anchorId: this.$route.params.id },
        params: { timeFilter: 'monthly' },
        version: 'v2'
      }).then(res => {
        this.anchoInfo = res;
      }).finally(() => {
        this.$toast.clear()
      });
    },
    contact() {
      if (this.$store.state.userLevel) {
        this.showContact = !this.showContact;
      } else {
        this.$store.commit('WRITEOVERLAYSHOW', {
          status: true,
          textChange: 'contact',
          yearVipOnly: { 0: true, 2: true }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.van-tabs__nav{
    scroll-behavior: unset!important;
}
/deep/.van-tab {
  flex: none;
}
/deep/.van-tabs__wrap--scrollable {
  flex: none;
}
.header {
  position: relative;
    //background: linear-gradient(#2a89f4 0%, #80bcff 100%);
  background:  #FFFFFF  ;
  padding: 0.3rem 0.4rem;
  color: #A1AEBF;

  .avatar-container {
    margin-right: 0.3rem;
    position: relative;

    .avatar {
      height: 1.6rem;
      width: 1.6rem;
      border-radius: 50%;
      border: 0.06rem solid rgba(216, 216, 216, 0.1);
      object-fit: cover;
    }

    .live-icon {
      color: #ffffff;
      width: 1.1rem;
      height: 0.36rem;
      line-height: 0.36rem;
      text-align: center;
      border-radius: 0.08rem;
      font-size: 0.24rem;
      background: #ff5500;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);

      .wave-icon {
        display: inline-flex;
        justify-content: space-between;
        width: 0.2rem;
        height: 0.25rem;
        transform: rotate(180deg);
        vertical-align: text-top;

        .line {
          border: 0.01rem solid #ffffff;
          background: #ffffff;
          height: 0.13rem;
          animation: stretch 0.9s infinite;
          vertical-align: baseline;
        }

        @keyframes stretch {
          0% {
            height: 0.13rem;
          }
          50% {
            height: 0.2rem;
          }
          100% {
            height: 0.13rem;
          }
        }
      }
    }
  }

  .roughly {
    width: 100%;
    color: #4a4a4a;
    .name {
      font-weight: 600;
      font-size: 0.36rem;
      margin-bottom: 0.2rem;
    }
    .info__box{
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      .ksId{
        max-width: 2.6rem;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        font-size: 0.26rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 0.26rem;
        margin-right: 0.04rem;
      }
      .fans {
        margin-left: .26rem;
        font-size: 0.26rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 0.26rem;
      }
    }
    .approve__box{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-top: 0.04rem;
      transform: translateX(-0.21rem);
      .approve{
        margin-top: 0.16rem;
        margin-left: 0.21rem;
        display: flex;
        align-items: center;
        .approve-text{
          max-width: 5rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-left: 0.04rem;
          line-height: 0.26rem;
          font-size: 0.24rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #4a4a4a;
        }
      }
      }
    }

  }

  .info {
    font-size: 0.24rem;
    margin: 0.24rem 0 0.2rem;

    .text {
      margin-right: 0.4rem;
    }
  }

  .introduction {
    font-size: 0.24rem;
    line-height: 0.35rem;
    padding-top: 0.03rem;
    position: relative;
    margin-right: 1.1rem;
  }

  .more-btn {
    font-size: 0.24rem;
    position: absolute;
    right: 0.4rem;
    top: 2.7rem;
    color: #4787EC;
    display: flex;
    align-items: center;
  }
.anchor-links{
  margin-top: 0.21rem;
}
.none-monitor {
  font-size: 0.28rem;
  color: #848f9c;
  line-height: 0.35rem;
  text-align: center;
}
</style>

<style lang="less">
.carrier-list {
  .header {
    .motend {
      font-family: number-bold;
      display: flex;
      height: 40px;
      margin-top: 0.24rem;
      .motend_box {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        span {
          font-size: 12px;
          color: #8E9AAE;
        }
        p {
          font-size: 16px;
          color:#252E39;
        }
      }
    }
    .btn-row {
      margin-top: 0.24rem;

      .van-button {
        background: #2A89F4;
        border: 0;
        border-radius: 0.08rem;
        color: #FFFFFF;
        margin-right: 0.1rem;
        height: 0.6rem;
        min-width: 1.5rem;
        font-size: 0.24rem;
        line-height: 0.24rem;
      }
    }
  }

  .van-hairline--top-bottom::after,
  .van-hairline-unset--top-bottom::after {
    border: none;
  }
}
</style>
